/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation033.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

interface IAnimation033SubItem {
  img: string;
  title: string;
  content: string;
}

interface IAnimation033Item {
  text: string;
  subtitle?: string;
  subItems?: IAnimation033SubItem[];
}

interface IAnimation033Props {
  items: IAnimation033Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation033: FunctionComponent<IAnimation033Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [modalItem, setModalItem] = useState<IAnimation033SubItem[]>();
  const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = useState<number[]>([]);
  const [show2, setShow2] = useState<number[]>([]);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation033 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation033 component ${className}`}>
      <img
        className="click-point"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      <div className="animation033-content">
        {items.map((itm: IAnimation033Item, idx: number) => (
          <div
            key={idx}
            className={`animation033-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="animation033-subcontent">
              <div className="animation033-indicator">0{idx + 1}</div>
              <div className="animation033-body">
                <span
                  className="animation033-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
                {itm.subtitle ? (
                  <span className="text sub-task-text">
                    <Button
                      style={{ fontSize: '1.4rem' }}
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                        setModalItem(itm.subItems);
                        setShow2([...show2, idx]);
                      }}
                    >
                      {itm.subtitle}
                      <img
                        className="click-point1"
                        hidden={show2.includes(idx)}
                        src={ImgPoint}
                        alt=""
                      />
                    </Button>
                  </span>
                ) : null}
              </div>
            </div>
            <div className="animation033-triangle" />
          </div>
        ))}
      </div>
      {modalItem && (
        <Modal
          width="80%"
          className="animation033-modal"
          title={
            <div className="animation033-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: modalItem[currPage]?.content }}
            />
          )}

          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow([...show, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={show.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation033;
